module.exports = __webpack_public_path__ + "static/media/plus-icon.5b6ddb59.svg";